import { render } from "./HelpPage.vue?vue&type=template&id=63389c67"
import script from "./HelpPage.vue?vue&type=script&lang=js"
export * from "./HelpPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__